document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('.menu-toggle');
  if (menuButton) {
    const nav = document.querySelector('.desktop-nav');
    const open = nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  }
  const player = event.target.closest('[data-player]');
  if (player) {
    const record = player.querySelector('.mini-record');
    const paused = record.classList.toggle('paused');
    player.querySelector('strong').textContent = paused ? '▶' : 'Ⅱ';
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.quick-add');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  button.disabled = true;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add product');
    const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => el.textContent = cart.item_count);
    const toast = document.querySelector('.juke-toast');
    toast.textContent = 'Added to your bag ✓';
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 1800);
  } catch (error) {
    window.location.href = form.closest('.product-card').querySelector('.product-media').href;
  } finally { button.disabled = false; }
});
